import { isValidElement } from "react";
import { Compose, renderIcon } from "../compose.android";
function Icon(param) {
  var { icons, colorRole, color } = param;
  var _icons_android_props_size, _ref, _ref1;
  var _icons_android_props_composeStyle, _icons_android_props_composeStyle1;
  if (!/* @__PURE__ */ isValidElement(icons.android) || icons.android.type !== Compose.Icon) throw new Error("One.UI.Icon icons.android must be a One.Android.Icon element");
  var size = (_icons_android_props_size = icons.android.props.size) !== null && _icons_android_props_size !== void 0 ? _icons_android_props_size : 24;
  return renderIcon({
    ...icons.android.props,
    style: [
      {
        width: size,
        height: size
      },
      icons.android.props.style
    ],
    composeStyle: {
      ...icons.android.props.composeStyle,
      width: (_ref = (_icons_android_props_composeStyle = icons.android.props.composeStyle) === null || _icons_android_props_composeStyle === void 0 ? void 0 : _icons_android_props_composeStyle.width) !== null && _ref !== void 0 ? _ref : size,
      height: (_ref1 = (_icons_android_props_composeStyle1 = icons.android.props.composeStyle) === null || _icons_android_props_composeStyle1 === void 0 ? void 0 : _icons_android_props_composeStyle1.height) !== null && _ref1 !== void 0 ? _ref1 : size,
      foregroundColor: color
    }
  }, color === void 0 ? colorRole !== null && colorRole !== void 0 ? colorRole : "primary" : void 0);
}
export {
  Icon
};
//# sourceMappingURL=Icon.android.js.map
